import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import ProductCard from '@/components/ProductCard';
import Spinner from '@/components/Spinner';
import { API } from '@/lib/utils';
import { useSEO } from '@/lib/useSEO';
import { ArrowLeft } from '@phosphor-icons/react';

export default function CategoryDetail() {
  const { slug } = useParams();
  const [category, setCategory] = useState(null);
  const [products, setProducts] = useState(null);

  useSEO({
    title: category ? `${category.name} voor je noodpakket` : null,
    description: category ? `${category.description} Vergelijk de beste opties en bestel bij Bol.com, Amazon of Coolblue.` : null,
    path: `/categorieen/${slug}`,
  });

  useEffect(() => {
    setCategory(null); setProducts(null);
    axios.get(`${API}/categories/${slug}`).then((r) => setCategory(r.data));
    axios.get(`${API}/products?category=${slug}&limit=100`).then((r) => setProducts(Array.isArray(r.data) ? r.data : [])).catch(console.error);
  }, [slug]);

  if (!category) return <Spinner />;

  return (
    <div data-testid={`page-category-${slug}`}>
      <section className="border-b border-border bg-card">
        <div className="container py-16 lg:py-20">
          <Link to="/categorieen" className="inline-flex items-center gap-1 text-sm font-medium text-muted-foreground hover:text-primary mb-6">
            <ArrowLeft size={16} /> Alle categorieën
          </Link>
          <div className="overline text-muted-foreground mb-4">Categorie</div>
          <h1 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">{category.name}</h1>
          <p className="mt-5 text-lg text-muted-foreground max-w-2xl leading-relaxed">{category.description}</p>
        </div>
      </section>
      <section className="container py-12 lg:py-16">
        {products === null ? <Spinner /> : products.length === 0 ? (
          <div className="text-center py-20 text-muted-foreground">Geen producten in deze categorie.</div>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
            {(products || []).map((p, i) => <ProductCard key={p.slug} product={p} index={i} />)}
          </div>
        )}
      </section>
    </div>
  );
}
